import { useContext } from "react";
import { v4 as uuid } from "uuid";

import classes from "./CreateBookForm.module.css";

import useDropdownMenu from "../../../hooks/DropDownMenu/useDropdownMenu";

import CartContext from "../../../store/cart-context";
import ShelfContext from "../../../store/shelf-context";

import useInput from "../../../hooks/input_hook";

// validate inputs
const isNotEmpty = (value) => value.trim() !== "";
const titleLetters = (value) => value.match(/^[a-zA-Z\s]*[a-zA-Z]$/);
const abrevLetters = (value) => value.match(/^[a-zA-Z]+$/);
const abrevCorrectLength = (value) =>
  value.trim().length > 0 && value.trim().length < 4;
const titleCorrectLength = (value) =>
  value.trim().length > 1 && value.trim().length < 25;
const isCorrectAbrev = (value) =>
  isNotEmpty(value) && abrevLetters(value) && abrevCorrectLength(value);
const isCorrectTitle = (value) =>
  isNotEmpty(value) && titleLetters(value) && titleCorrectLength(value);

// component for creating a book from drinks in cart
const CreateBookForm = (props) => {
  const cartCtx = useContext(CartContext);
  const shelfCtx = useContext(ShelfContext);

  const colours = ["red", "green", "beige", "tan"]; // colours a book can be

  // drop down for selecting book colour
  const {
    DropdownMenu,
    selectedOption: colourValue,
    isValid: colourIsValid,
  } = useDropdownMenu(colours);

  // close the form
  const closeButtonHandler = () => {
    resetAbrev();
    resetTitle();
    props.closeForm();
  };

  // hook for title input
  const {
    value: titleValue,
    isValid: titleIsValid,
    valueChangeHandler: titleChangeHandler,
    inputBlurHandler: titleBlurHandler,
    reset: resetTitle,
    borderColor: titleBorderColor,
  } = useInput(isCorrectTitle);

  // hook for abreviation input (abreviation max 3 letters written on book spine)
  const {
    value: abrevValue,
    isValid: abrevIsValid,
    valueChangeHandler: abrevChangeHandler,
    inputBlurHandler: abrevBlurHandler,
    reset: resetAbrev,
    borderColor: abrevBorderColor,
  } = useInput(isCorrectAbrev);

  // check form is value before submission
  let formIsValid = false;

  if (titleIsValid && abrevIsValid & colourIsValid) {
    formIsValid = true;
  }

  // submit form
  const submitHandler = (event) => {
    event.preventDefault();

    if (!formIsValid) {
      return;
    }

    // default colour;
    var bookColour = "rgb(255, 194, 92)";

    switch (colourValue) {
      case "red":
        bookColour = "rgb(114, 10, 1)";
        break;
      case "green":
        bookColour = "rgb(38, 78, 1)";
        break;
      case "tan":
        bookColour = "rgb(163, 84, 1)";
        break;
      case "beige":
        bookColour = "rgb(255, 194, 92)";
        break;
      default:
        bookColour = "rgb(255, 194, 92)";
    }

    // set unique id for book
    const bookId = uuid();

    const book = {
      id: bookId,
      title: titleValue,
      abrev: abrevValue,
      colour: bookColour,
      items: cartCtx.items,
      ingredients: cartCtx.ingredients,
    };

    resetAbrev();
    resetTitle();

    shelfCtx.addBook(book);
    shelfCtx.saveBooks();
    cartCtx.clearCart();
    cartCtx.saveCart();
    closeButtonHandler();
  };

  return (
    <form className={classes.form} onSubmit={submitHandler}>
      <div className={classes.form_header}>
        Create Book
      </div>
      <div class={classes.form_body}>
        <div class={classes.form_sub_section}>
          <label className={classes.label}> Book Title</label>
          <input
            type="text"
            id="title"
            className={classes.input}
            value={titleValue}
            onChange={titleChangeHandler}
            onBlur={titleBlurHandler}
            style={{
              borderColor: ` ${titleBorderColor}`,
              backgroundColor: "#FBEEC1",
            }}
          />
        </div>
        <div class={classes.form_sub_section}>
          <label className={classes.label}> 3 Letter Abreviation</label>
          <input
            type="text"
            id="abrev"
            className={classes.input}
            value={abrevValue}
            onChange={abrevChangeHandler}
            onBlur={abrevBlurHandler}
            style={{
              borderColor: ` ${abrevBorderColor}`,
              backgroundColor: "#FBEEC1",
              width: "30%",
            }}
          />
        </div>
        <div class={classes.form_sub_section}>
          <label className={classes.label}> Book Colour</label>
          <DropdownMenu options={colours} />
        </div>
      </div>

      <div class={classes.form_footer}>
        <div className={classes.closeButton} onClick={closeButtonHandler}>
          Close
        </div>
        <div
          disabled={!formIsValid}
          className={classes.submitButton}
          onClick={submitHandler}
        >
          Submit
        </div>
      </div>
    </form>
  );
};

export default CreateBookForm;
